<template>
  <div class="container" @click="_closeAll">
    <template v-if="status === 200 && channelInfo.id">
      <skin :layoutColor="channelInfo.layoutColor"></skin>
      <mobile v-if="isMobile && channelInfo.pageMode === 'normal'"></mobile>
      <new-mobile v-if="isMobile && channelInfo.pageMode === 'audio'"></new-mobile>
      <pc v-if="!isMobile"></pc>
    </template>
    <template v-else-if="status === 404">
      <status404></status404>
    </template>
    <template v-else-if="status === 408">
      <status408></status408>
    </template>
    <template v-else>
      <div class="loading"></div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import DMS from "@/utils/Mixin/dms";
import UserAgent from "@/utils/UserAgent/index";
import websocketHeartbeat from '@/utils/Common/WSTimer/websocketHeartbeat'
const skin = (resolve) => require(["@/assets/skin/index"], resolve);
const viewPc = (resolve) => require(["@/components/view/pc"], resolve);
const viewMobile = (resolve) => require(["@/components/view/mobile"], resolve);
const newMobile = (resolve) => require(["@/components/view/newMobile"], resolve);
const status404 = (resolve) => require(["@/components/view/404"], resolve);
const status408 = (resolve) => require(["@/components/view/408"], resolve);
export default {
  components: {
    skin: skin,
    pc: viewPc,
    mobile: viewMobile,
    newMobile: newMobile,
    status404: status404,
    status408: status408,
  },
  mixins: [DMS],
  data() {
    return {
      timer: null,
      isMobile: true,
    };
  },
  head() {
    return {
      title: this.domTitle,
    };
  },
  computed: {
    ...mapGetters({
      status: "status",
      channelInfo: "channelInfo",
      userInfo: "userInfo",
    }),
    domTitle() {
      if (this.status === 200) {
        return this.channelInfo.name || "";
      } else if (this.status === 404) {
        return "抱歉，您的页面迷路了";
      } else if (this.status === 408) {
        return "直播间人数较多，请耐心等待";
      } else {
        return this.channelInfo.name || "";
      }
    },
    id() {
      return Number(this.$route.params.id) || Number(this.$route.query.id)
    }
  },
  watch: {
    'channelInfo.uin'() {
      this.get_userInfo();
      this.timer = websocketHeartbeat.call(this)
      this.set_uuid(this.timer.uuid);
          // 进入连接
      this.timer.onOpen = (e) => {
        this.timer.send("start");
      };
      this.timer.onMessage = (e) => {
        console.log(`onmessage: ${e.data}`);
      };
    },
    domTitle() {
      document.title = this.domTitle
    },
  },
  async created() {
    // REPORT($sentry, { AppId: params.id, Uin: query.uin });
    await this.$store.dispatch("get_control", { id: this.id, uin: this.$route.query.uin });
  },
  async mounted() {
    // if (this.status !== 200) {
    //   return false;
    // }
    let mobile = Number(this.$route.query.mobile);
    this.isMobile = mobile || UserAgent.isMobile();
    this.set_corpId(Number(this.$route.query.corpId));
    // await this.$store.dispatch("get_control", { id: this.$route.params.id, uin: this.$route.query.uin });

    // bus注册ws暂停和开始事件
    this.$Bus.$on("ws-start", () => {
      this.timer && this.timer.start();
    });
    this.$Bus.$on("ws-stop", () => {
      this.timer && this.timer.stop();
    });
    this.$Bus.$on("ws-changeLiveNowStatus", (newState) => {
      this.timer.useIt("userInfo", { liveNowStatus: newState });
    });
    if (this.$route.query.debugger === "gdyfe") {
      const Vconsole = require("vconsole");
      // eslint-disable-next-line no-new
      new Vconsole();
    }
  },
  methods: {
    ...mapMutations({
      set_corpId: "set_corpId",
      set_uuid: "set_uuid",
    }),
    ...mapActions({
      get_userInfo: "get_userInfo",
    }),
    _closeAll() {
      this.$Bus.$emit("bus-remEnclosure");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  overflow: hidden;
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: #fbfbfb;
    background-image: url("~@/assets/img/loading.gif");
    background-repeat: no-repeat;
    background-size: 270px auto;
    background-position: center center;
  }
}
</style>
